import { render } from "./ContentPlaceHolder.vue?vue&type=template&id=e04a4e92&scoped=true"
import script from "./ContentPlaceHolder.vue?vue&type=script&lang=js"
export * from "./ContentPlaceHolder.vue?vue&type=script&lang=js"

import "./ContentPlaceHolder.vue?vue&type=style&index=0&id=e04a4e92&scoped=true&lang=css"

import exportComponent from "/home/admin/domains/web3.owatts.io/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e04a4e92"]])

export default __exports__